// extracted by mini-css-extract-plugin
export default {"content":"style_content__-xsuG","section":"style_section__OZ-NR","subTitle":"style_subTitle__KGF+b","title":"style_title__WGYnZ","header":"style_header__NfmMV"};